var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92009 11.4699C7.33011 11.4699 8.46013 12.6109 8.46013 14.0309V17.44C8.46013 18.85 7.33011 20 5.92009 20H2.54004C1.14002 20 0 18.85 0 17.44V14.0309C0 12.6109 1.14002 11.4699 2.54004 11.4699H5.92009ZM17.4604 11.4699C18.8604 11.4699 20.0004 12.6109 20.0004 14.0309V17.44C20.0004 18.85 18.8604 20 17.4604 20H14.0803C12.6703 20 11.5403 18.85 11.5403 17.44V14.0309C11.5403 12.6109 12.6703 11.4699 14.0803 11.4699H17.4604ZM5.92009 0C7.33011 0 8.46013 1.15002 8.46013 2.56104V5.97009C8.46013 7.39011 7.33011 8.53013 5.92009 8.53013H2.54004C1.14002 8.53013 0 7.39011 0 5.97009V2.56104C0 1.15002 1.14002 0 2.54004 0H5.92009ZM17.4604 0C18.8604 0 20.0004 1.15002 20.0004 2.56104V5.97009C20.0004 7.39011 18.8604 8.53013 17.4604 8.53013H14.0803C12.6703 8.53013 11.5403 7.39011 11.5403 5.97009V2.56104C11.5403 1.15002 12.6703 0 14.0803 0H17.4604Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.e60c55c5f7d407337085ebe89c5bc8fd.svg";
export { ForwardRef as ReactComponent };